import { useAdditionalServicesMasterdataQuery } from "@/features/masterdata/queries/additional-services-masterdata-query";
import { FunctionalGroupCode } from "@/types/DocumentTypes";

export function useAdditionalServicesMasterdata() {
  const query = useAdditionalServicesMasterdataQuery();

  const additionalServices = computed(() => query.data.value || []);

  function getAdditionalServicesByFGCode(code: FunctionalGroupCode) {
    return additionalServices.value.filter((item) => item.functional_group_code === code);
  }

  function getAdditionalServiceNameByCodes(code: FunctionalGroupCode, additionalServiceCodes: string[]) {
    const match = getAdditionalServicesByFGCode(code).find((item) => additionalServiceCodes.includes(item.code));
    return match?.name ?? "";
  }

  return {
    additionalServices,
    getAdditionalServicesByFGCode,
    getAdditionalServiceNameByCodes,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
